import Api from './ApiProvider';

export interface Message {
  id?: string;
  direction: 'incoming' | 'outgoing';
  type: 'CHOOSE_ONE' | 'TEXT';
  content: string;
  options?: string[];
  category?: string;
  ratable?: boolean;
  useful?: boolean;
}

export interface MagicAiStatusResponse {
  isAvailable: boolean;
  messages: Message[];
  usage: {
    creditsLimit: number;
    creditsUsed: number;
  };
}

export interface MagicAiGetDialogResponse {
  info: {
    id: string;
    header: string;
  };
  messages: Message[];
}

export interface MagicAiDialogsListItem {
  info: {
    id: string;
    header: string;
    createdAt: string;
  };
}

export const getAiAssistantStatus = () => {
  return Api.get('v2/store/assistant/status').json<MagicAiStatusResponse>();
};

export const getAiAssistantQuotas = () => {
  return Api.get('v2/store/assistant/quotas').json<{ minSQRv: number; monthCredits: number }[]>();
};

export const getAiAssistantHistory = () => {
  return Api.get('v2/store/assistant/usage-history').json<
    { date: string; creditsUsed: number }[]
  >();
};

export const clearAiAssistantCurrentDialog = () => {
  return Api.post('v2/store/assistant/dialogs/clear-current').json<MagicAiGetDialogResponse>();
};

export const getDialogById = (id: string) => {
  return Api.get(`v2/store/assistant/dialogs/${id}`).json<MagicAiGetDialogResponse>();
};

export const getDialogsList = () => {
  return Api.get(`v2/store/assistant/dialogs`).json<MagicAiDialogsListItem[]>();
};

export const createNewDialog = () => {
  return Api.post(`v2/store/assistant/dialogs`).json<MagicAiGetDialogResponse>();
};
